export default "__VITE_ASSET__Bpb1aF5i__"